export const roundedInputSx = {
  height: 36,
  borderRadius: '100px',
  px: 2,
};
